export interface Video {
  id: string;
  title: string;
  thumbnail: string;
  category: string;
  duration: string;
  views: string;
  rating: number;
  description: string;
  quality: string;
  year: number;
  tags: string[];
}

export const categories = [
  { id: 'all', name: '全部', slug: 'all', description: '浏览全部精彩视频内容' },
  { id: 'movie', name: '电影', slug: 'movie', description: '最新热门电影高清在线观看' },
  { id: 'tv', name: '电视剧', slug: 'tv', description: '热门电视剧全集免费观看' },
  { id: 'variety', name: '综艺', slug: 'variety', description: '热门综艺节目在线观看' },
  { id: 'anime', name: '动漫', slug: 'anime', description: '热门动漫番剧高清在线' },
  { id: 'documentary', name: '纪录片', slug: 'documentary', description: '精选纪录片在线观看' },
  { id: 'short', name: '短视频', slug: 'short', description: '精彩短视频合集' },
];

export const allVideos: Video[] = [
  {
    id: 'v001',
    title: '时空穿越者：未来之战',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20featuring%20a%20futuristic%20sci-fi%20scene%20with%20glowing%20neon%20lights%2C%20a%20hero%20in%20advanced%20armor%20standing%20against%20a%20dystopian%20cityscape%20at%20sunset%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20teal%20color%20grade%2C%20cinematic%20composition&width=640&height=360&seq=movie-01&orientation=landscape',
    category: 'movie',
    duration: '2:18:45',
    views: '1280万',
    rating: 9.2,
    description: '在未来的2150年，人类面临前所未有的危机，一名年轻的科学家意外发现了时空穿越的秘密，踏上拯救人类命运的史诗旅程...',
    quality: '4K',
    year: 2026,
    tags: ['科幻', '动作', '冒险', '时空穿越'],
  },
  {
    id: 'v002',
    title: '深海迷踪',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20mysterious%20underwater%20scene%20with%20a%20submarine%20approaching%20ancient%20ruins%20deep%20in%20the%20ocean%2C%20bioluminescent%20creatures%2C%20dark%20blue%20tones%2C%20cinematic%20wide%20shot%2C%20epic%20adventure%20movie%20aesthetic&width=640&height=360&seq=movie-02&orientation=landscape',
    category: 'movie',
    duration: '1:56:23',
    views: '980万',
    rating: 8.8,
    description: '海底探险队在一次考古任务中发现了失落的古代文明遗迹，但他们不知道的是，深海中隐藏着不可告人的秘密...',
    quality: '4K',
    year: 2026,
    tags: ['冒险', '悬疑', '海洋', '考古'],
  },
  {
    id: 'v003',
    title: '江湖风云录',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20martial%20arts%20film%20scene%20in%20ancient%20China%2C%20warriors%20in%20traditional%20clothing%20standing%20on%20a%20misty%20mountain%20peak%20at%20sunrise%2C%20warm%20golden%20light%2C%20epic%20wuxia%20cinematic%20style&width=640&height=360&seq=movie-03&orientation=landscape',
    category: 'movie',
    duration: '2:05:18',
    views: '1560万',
    rating: 9.5,
    description: '江湖恩怨情仇，一段传奇的武侠故事。少年侠客从无名小卒成长为一代宗师的热血旅程...',
    quality: '4K',
    year: 2026,
    tags: ['武侠', '古装', '动作', '爱情'],
  },
  {
    id: 'v004',
    title: '星空下的约定',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20romantic%20scene%20of%20a%20couple%20sitting%20under%20a%20starry%20night%20sky%20on%20a%20hilltop%20overlooking%20a%20city%2C%20warm%20tender%20mood%2C%20cinematic%20romance%20film%20aesthetic%2C%20soft%20lighting&width=640&height=360&seq=movie-04&orientation=landscape',
    category: 'movie',
    duration: '1:48:12',
    views: '890万',
    rating: 8.6,
    description: '两个来自不同世界的年轻人，在一场流星雨后命运般地相遇。他们的爱情故事，如星空般璀璨而短暂...',
    quality: '1080P',
    year: 2025,
    tags: ['爱情', '剧情', '浪漫', '青春'],
  },
  {
    id: 'v005',
    title: '都市夜行者 第一季',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20gritty%20urban%20night%20scene%20with%20a%20detective%20in%20a%20trench%20coat%20walking%20through%20rain-slicked%20neon-lit%20streets%2C%20noir%20aesthetic%2C%20dramatic%20shadows%2C%20TV%20series%20promotional%20style&width=640&height=360&seq=tv-01&orientation=landscape',
    category: 'tv',
    duration: '45分钟/集',
    views: '2350万',
    rating: 9.1,
    description: '讲述了都市夜幕下，一群不为人知的夜行者们守护城市安全的故事。每集一个独立案件，环环相扣。',
    quality: '4K',
    year: 2026,
    tags: ['悬疑', '犯罪', '都市', '剧情'],
  },
  {
    id: 'v006',
    title: '大唐荣耀',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20magnificent%20Tang%20Dynasty%20palace%20scene%20with%20royal%20figures%20in%20elaborate%20traditional%20Chinese%20costumes%2C%20golden%20and%20red%20color%20palette%2C%20grand%20imperial%20court%2C%20historical%20drama%20cinematic%20style&width=640&height=360&seq=tv-02&orientation=landscape',
    category: 'tv',
    duration: '50分钟/集',
    views: '3120万',
    rating: 9.6,
    description: '以盛唐为背景的大型古装剧，讲述了一代女帝的传奇人生。权谋、爱情、家国天下的恢弘史诗。',
    quality: '4K',
    year: 2026,
    tags: ['古装', '历史', '权谋', '爱情'],
  },
  {
    id: 'v007',
    title: '欢乐小厨神',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20colorful%20cooking%20show%20studio%20set%20with%20cheerful%20contestants%20cooking%2C%20professional%20kitchen%20lighting%2C%20warm%20and%20inviting%20atmosphere%2C%20variety%20show%20aesthetic&width=640&height=360&seq=variety-01&orientation=landscape',
    category: 'variety',
    duration: '90分钟/期',
    views: '890万',
    rating: 8.5,
    description: '明星大厨与素人选手同台竞技，用美食传递快乐。每一期都有令人垂涎的创意料理和温馨故事。',
    quality: '1080P',
    year: 2026,
    tags: ['美食', '竞技', '明星', '娱乐'],
  },
  {
    id: 'v008',
    title: '声临其境 第五季',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20professional%20voice%20acting%20competition%20stage%20with%20dramatic%20lighting%2C%20a%20performer%20at%20a%20microphone%2C%20judges%20in%20the%20background%2C%20theatrical%20atmosphere%2C%20TV%20show%20production%20style&width=640&height=360&seq=variety-02&orientation=landscape',
    category: 'variety',
    duration: '120分钟/期',
    views: '2100万',
    rating: 9.0,
    description: '国内顶级声优竞技节目，各路声音大咖同台比拼，用声音演绎精彩故事，震撼你的听觉。',
    quality: '4K',
    year: 2026,
    tags: ['配音', '竞技', '声音', '娱乐'],
  },
  {
    id: 'v009',
    title: '星辰大海',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20beautiful%20anime-style%20space%20adventure%20scene%20with%20a%20young%20hero%20and%20a%20starship%20flying%20through%20colorful%20nebula%20clouds%2C%20vibrant%20colors%2C%20epic%20composition%2C%20Japanese%20animation%20aesthetic&width=640&height=360&seq=anime-01&orientation=landscape',
    category: 'anime',
    duration: '24分钟/集',
    views: '5600万',
    rating: 9.7,
    description: '少年与他的伙伴们驾驶星际飞船，在浩瀚宇宙中展开一场寻找新家园的冒险。画面精美，剧情扣人心弦。',
    quality: '4K',
    year: 2026,
    tags: ['科幻', '冒险', '热血', '友情'],
  },
  {
    id: 'v010',
    title: '剑与魔法学院',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fantasy%20anime%20academy%20scene%20with%20young%20magic%20students%20in%20robes%2C%20a%20grand%20magical%20castle%20school%20background%2C%20floating%20spell%20effects%2C%20warm%20golden%20light%2C%20anime%20style&width=640&height=360&seq=anime-02&orientation=landscape',
    category: 'anime',
    duration: '24分钟/集',
    views: '4200万',
    rating: 9.3,
    description: '普通少年偶然获得了一把传说中的魔法剑，被神秘学院录取。在这里他结识了一群志同道合的伙伴...',
    quality: '1080P',
    year: 2026,
    tags: ['奇幻', '校园', '魔法', '成长'],
  },
  {
    id: 'v011',
    title: '地球脉动：蔚蓝纪元',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20nature%20documentary%20scene%20of%20a%20humpback%20whale%20breaching%20in%20the%20ocean%20with%20sunlight%20streaming%20through%20the%20water%2C%20crystal%20clear%20blue%2C%20BBC%20style%20wildlife%20photography&width=640&height=360&seq=doc-01&orientation=landscape',
    category: 'documentary',
    duration: '52分钟/集',
    views: '1800万',
    rating: 9.8,
    description: '用超高清镜头记录了全球海洋生态系统的壮丽奇观，从热带珊瑚礁到极地冰海，带你领略蓝色星球的震撼之美。',
    quality: '4K',
    year: 2026,
    tags: ['自然', '海洋', '动物', '环保'],
  },
  {
    id: 'v012',
    title: '味蕾中国',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20traditional%20dishes%20on%20a%20rustic%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20mouth-watering%20close-up%2C%20food%20photography%20style&width=640&height=360&seq=doc-02&orientation=landscape',
    category: 'documentary',
    duration: '48分钟/集',
    views: '2600万',
    rating: 9.4,
    description: '走遍中国大江南北，探寻各地独特美食背后的文化故事。每一道菜都是一段历史，每一口都是人间至味。',
    quality: '4K',
    year: 2025,
    tags: ['美食', '文化', '旅行', '传统'],
  },
  {
    id: 'v013',
    title: '一分钟看世界',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dynamic%20montage%20of%20world%20landmarks%20and%20cultural%20moments%20in%20fast%20succession%2C%20vibrant%20colors%2C%20vertical%20video%20style%2C%20social%20media%20aesthetic%2C%20energetic%20composition&width=640&height=360&seq=short-01&orientation=landscape',
    category: 'short',
    duration: '1-3分钟',
    views: '8900万',
    rating: 8.9,
    description: '每天一分钟，带你足不出户看遍全球精彩瞬间。旅行、美食、科技、趣闻应有尽有。',
    quality: '1080P',
    year: 2026,
    tags: ['旅行', '知识', '趣闻', '日常'],
  },
  {
    id: 'v014',
    title: '搞笑动物合集',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20funny%20compilation%20of%20cute%20cats%20and%20dogs%20doing%20silly%20things%2C%20bright%20and%20cheerful%20mood%2C%20pet%20photography%20style%2C%20warm%20home%20background&width=640&height=360&seq=short-02&orientation=landscape',
    category: 'short',
    duration: '2-5分钟',
    views: '12500万',
    rating: 9.1,
    description: '精选全球最搞笑的宠物视频合集，毛孩子们的可爱瞬间让你捧腹大笑，治愈你的每一天。',
    quality: '1080P',
    year: 2026,
    tags: ['搞笑', '宠物', '治愈', '合集'],
  },
  {
    id: 'v015',
    title: '极限追击',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20intense%20police%20chase%20scene%20through%20busy%20city%20streets%20at%20night%2C%20action%20movie%20aesthetic%2C%20explosive%20lighting%2C%20fast-paced%20thriller%20cinematic%20composition%2C%20warm%20orange%20mood&width=640&height=360&seq=movie-05&orientation=landscape',
    category: 'movie',
    duration: '1:42:35',
    views: '760万',
    rating: 8.3,
    description: '警探与时间赛跑，在48小时内追捕一个跨越三座城市的犯罪集团。每一秒都让人屏住呼吸的紧张动作片。',
    quality: '4K',
    year: 2026,
    tags: ['动作', '犯罪', '悬疑', '警匪'],
  },
  {
    id: 'v016',
    title: '温暖的房间 第二季',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cozy%20interior%20scene%20of%20a%20warm%20living%20room%20with%20soft%20lamplight%2C%20friends%20gathered%20around%20a%20coffee%20table%2C%20slice%20of%20life%20drama%20aesthetic%2C%20warm%20amber%20tones&width=640&height=360&seq=tv-03&orientation=landscape',
    category: 'tv',
    duration: '42分钟/集',
    views: '1870万',
    rating: 9.0,
    description: '几个年轻人在大城市合租的故事，温馨治愈，笑中带泪。每个角色都有自己的梦想和挣扎...',
    quality: '1080P',
    year: 2026,
    tags: ['都市', '友情', '爱情', '治愈'],
  },
];